import { render, staticRenderFns } from "./portrait.vue?vue&type=template&id=62133581&scoped=true"
import script from "./portrait.vue?vue&type=script&lang=js"
export * from "./portrait.vue?vue&type=script&lang=js"
import style0 from "./portrait.vue?vue&type=style&index=0&id=62133581&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62133581",
  null
  
)

export default component.exports